<template>
  <div class="checkout-products">
    <div
      v-for="product in products"
      class="checkout-products__item d-flex align-items-center"
      secondary
      block
      :key="product.id"
      @click="() => $emit('select', product)"
    >
      <div>
        <h4>{{ product.title }}</h4>

        <p class="mt-0 mb-0 text-grey-70">
          {{ product.symbol || "$" }}{{ product.price }}
          {{ product.currency }}
          <template v-if="product.interval">
            {{
              productInterval({
                interval: product.interval,
                intervalCount: product.interval_count,
                expiryUnits: product.expiry_units
              })
            }}
          </template>
        </p>
      </div>

      <div class="ml-auto">
        <v-icon size="1.5rem" icon="chevron_right" />
      </div>
    </div>
  </div>
</template>

<script>
import { productInterval } from "@/lib/product-interval"

export default {
  props: {
    products: { type: Array, default: () => [] }
  },

  methods: {
    productInterval
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables";
@import "@/assets/styles/mixins";

.checkout-products__item {
  @include clickable;

  background: $color-ui--white;
  box-shadow: var(--card-shadow);
  border: 2px solid $color-ui--grey-20;
  padding: $size--4 $size--3 $size--3 $size--4;
  border-radius: var(--border-radius);
  margin-bottom: $size--4;
  transition: all 0.2s ease;

  h4 {
    margin: 0;
    font-size: $size--4;
  }

  p {
    font-size: $font-size--small;
    font-weight: $font-weight--semi-bold;
  }

  .v-icon {
    position: relative;
    top: 2px;
    color: $color-ui--grey-60;
  }

  &:hover {
    background: $color-ui--grey-10;
  }
}
</style>
